import BaseHeading from "../../baseComponents/baseHeading.js";
import { Container, Row, Col } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import LanguageSelector from "../../components/LanguageSelector.js";
import ThemeSelector from "../../components/ThemeSelector";
import { useEffect, useState } from "react";
import LoadingView from "../utilitiesStack/LoadingView.js";
import Message from "../../components/Message.js";
import BaseImage from "../../baseComponents/baseImage.js";
import { useNavigate, useLocation } from "react-router-dom";
import useBootstrap from "../../customHooks/useBootstrap.js";
import useColors from "../../customHooks/useColors.js";
import WithTemplateWrapper from "../../HOC/WithTemplateWrapper.js";

import {
  actions as loginActions,
  asyncActions as loginAsyncActions,
} from "../../store/slices/loginSlice.js";

export let loginId = 0;

export let incrementLoginId = () => {
  ++loginId;
};

let reloginId = 0;
let incrementReloginId = () => {
  ++reloginId;
};

const LoginTemplate = ({
  templateWrapperOptions = {},
  heading,
  children,
  onEnter,
  showPickers = true,
  icon,
  error,
  success,
  autoRelogin = true,
  isElevated = false,
  translate = true,
  focusElement = null,
  stretchNoColumns = false,
  afterLoginRoutesPath = [],
  loginRoutesPath = [],
  hideTemplateOnSuccess = false,
  isInModal = false,
  modalFullyOpened = false,
}) => {
  //////////////////////////////////////////REDUX STATE
  const [currentColors] = useColors();
  const loginState = useSelector((state) => state.loginState);
  const systemState = useSelector((state) => state.systemState);
  const successState = useSelector((state) => state.successState);
  const loadingState = useSelector((state) => state.loadingState);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  //////////////////////////////////////////LOCAL STATE

  //////////////////////////////////////////VARIABLES DERIVED FROM STATE
  const message = {
    isErrorOrSuccess: error == "" || error == null ? "s" : "e",
    message:
      ((error ?? "" !== "" ? error : null) ||
        (success ?? "" !== "" ? success : null)) ??
      "",
    isVisible: (error ?? "" !== "") || (success ?? "" !== ""),
  };

  //////////////////////////////////////////STYLES
  const styles = {
    cardDiv: {
      backgroundColor: currentColors.quinary,
      margin: "1em",
    },
    logoContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      marginBottom: "1.5em",
    },
    heading: {
      marginBottom: "1em",
    },
    iconContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      marginBottom: "1em",
    },
    elevated: {
      borderRadius: 20,
      boxShadow:
        "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
    },
  };

  if (isElevated) {
    styles.cardDiv = { ...styles.cardDiv, ...styles.elevated };
  }

  //////////////////////////////////////////BOOTSTRAP TRASHOLD

  const { trashold, trashold4, trashold12 } = useBootstrap();
  const currentTrashold = stretchNoColumns ? trashold12 : trashold4;

  //////////////////////////////////////////AUTORELOGIN
  useEffect(() => {
    let responsePromise;
    if (autoRelogin && systemState.systemSettingsFetchStarted) {
      incrementLoginId();
      incrementReloginId();
      responsePromise = dispatch(
        loginAsyncActions.relogin({ loginId: loginId, reloginId: reloginId })
      );

      responsePromise.then((res) => {
        const currentPath = location.pathname;
        if (!res.error) {
          const parsedRes = JSON.parse(res.payload.P_RESULT);
          const isSuccess = parsedRes.isSuccess;
          if (isSuccess === true) {
            if (loginRoutesPath.length === 0) {
              if (!afterLoginRoutesPath.includes(currentPath)) {
                if (loginState.login.isLoggedIn === false) {
                  navigate("/");
                }
              }
            } else {
            }
          } else {
          }
        } else {
          //tu je abortan relogin
          if (res.meta?.aborted === false) {
            if (afterLoginRoutesPath.includes(currentPath)) {
              if (loginState.login.isLoggedIn === false) {
                navigate("/");
              }
            }
          }
        }
      });
    }

    return () => {
      if (responsePromise) {
        responsePromise.abort();
      }
    };
  }, []);

  useEffect(() => {
    
    setTimeout(() => {
      const innerElement = focusElement?.current;

      if (innerElement) {
        if (
          isInModal === false ||
          (isInModal === true && modalFullyOpened === true)
        ) {
          try {
           
            innerElement.focus();
          } catch (err) {
          
          }
        }
      }
    }, 50);
  }, [modalFullyOpened, isInModal, focusElement?.current]);

  //////////////////////////////////////////relogging
  if (loginState.login.isReloggingInBucket.length > 0) {
    return (
      <div>
        <LoadingView showAnimationAfterMS={0} />
      </div>
    );
  }

  ///////////////////////////////////////////////render
  return (
    <>
      <Container
        className="fade-in"
        fluid
        style={{
          flex: 1,
          display:
            successState.showSuccessBucket.length > 0
              ? hideTemplateOnSuccess
                ? "none"
                : "flex"
              : "flex",
          flexDirection: "column",
          alignItems: "stretch",
          justifyContent: "flex-start",
          height: "100%",
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (onEnter instanceof Function) {
              onEnter();
            }
          }
        }}
      >
        {showPickers && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifySelf: "flex-start",
              justifyContent: "flex-end",
              marginTop: "1em",
            }}
          >
            <span style={{ marginRight: "1em" }}>
              <ThemeSelector />
            </span>
            <span style={{ marginRight: "1em" }}>
              <LanguageSelector />
            </span>
          </div>
        )}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "stretch",
          }}
        >
          <Row>
            {stretchNoColumns === false && <Col {...currentTrashold}></Col>}
            <Col {...currentTrashold}>
              <div style={styles.cardDiv} className={`p-3 p-${trashold}-5`}>
                <div style={styles.logoContainer}>
                  <BaseImage src={"logo"} />
                </div>

                {icon && (
                  <div style={styles.iconContainer}>
                    <BaseImage
                      buildSrcFromConnection={false}
                      src={icon}
                      style={{ width: "40%" }}
                    />
                  </div>
                )}

                <div style={styles.heading}>
                  <BaseHeading>{heading}</BaseHeading>
                </div>
                <Message
                  isError={message.isErrorOrSuccess === "e"}
                  translate={translate}
                  style={{ display: message.message ? "block" : "none" }}
                >
                  {message.message}
                </Message>

                {children}
              </div>
            </Col>
            {stretchNoColumns === false && <Col {...currentTrashold}></Col>}
          </Row>
        </div>
      </Container>
      {(loadingState.loadingBucket.length > 0 ||
        loginState.login.isLoggingInBucket.length > 0 ||
        loginState.register.isRegistring ||
        loginState.login.isReloggingInBucket.length > 0) && (
        <>
          <LoadingView />
        </>
      )}
    </>
  );
};

export default WithTemplateWrapper(LoginTemplate);
